<template>
  <div class="global-library">
    <!-- 工具栏 -->
    <div class="toolbar">
      <div class="toolbar-left">
        <el-select v-model="docType" size="small" style="width: 120px;" @change="handleSearch" clearable>
          <el-option label="全部文档类型" :value="0"></el-option>
          <el-option label="图文文档" :value="3"></el-option>
          <el-option label="问答对文档" :value="4"></el-option>

        </el-select>
        
        <el-select v-model="selectedDirId" size="small" style="width: 180px;" @change="handleSearch" clearable>
          <el-option label="全部目录" :value="null"></el-option>
          <el-option v-for="dir in dirs" :key="dir.id" :label="dir.name" :value="dir.id"></el-option>
        </el-select>
        
        <el-input 
          v-model="keyword" 
          placeholder="搜索关键字" 
          size="small"
          style="width: 200px;"
          clearable
          @keyup.enter="handleSearch"
          @clear="handleSearch">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        
        <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
      </div>
    </div>
    
    <!-- 统计信息 -->
    <div class="stats-bar" v-if="docStats">
     <span>📄 文档数量：{{ docStats.count }} / {{ maxFileCount }}</span>
    </div>
    
    <!-- 表格 -->
    <el-table
      :data="docList"
      v-loading="loading"
      stripe
      style="width: 100%;height: auto;">
      <el-table-column prop="title" label="标题" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
          <el-tag v-if="scope.row.doc_type == 1" size="mini" type="info">(文件)</el-tag>
          <el-tag v-else-if="scope.row.doc_type == 4" size="mini" type="success">(问答对)</el-tag>
          <el-tag v-else-if="scope.row.doc_type == 3" size="mini" type="warning">(图文)</el-tag>
        </template>
      </el-table-column>    
      <el-table-column prop="status" label="全局文档库状态" width="120">
        <template slot-scope="scope">
   <span style="display:none">{{ debugLog(scope.row) }}</span>         
          <el-tag :type="getLiabraryStatusType(scope.row.status,  scope.row.is_in_document_library)" size="small" v-if="scope.row.doc_type!=4">
            {{ getLiabraryStatusText(scope.row.status,  scope.row.is_in_document_library) }}
          </el-tag>
          <el-tag :type="getLiabraryStatusType2(scope.row.inLibraryCount,  scope.row.totalQaCount)" size="small" v-if="scope.row.doc_type==4">
            {{ getLiabraryStatusText2(scope.row.inLibraryCount,  scope.row.totalQaCount) }}
          </el-tag> 
        </template>
      </el-table-column>
      <el-table-column prop="status" label="知识库状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="getWorkspaceStatusType(scope.row.isInWorkspace)" size="small"  v-if="scope.row.doc_type!=4">
            {{ getWorkspaceStatusText(scope.row.isInWorkspace) }}
          </el-tag>
          <el-tag :type="getWorkspaceStatusType(scope.row.isInWorkspace)" size="small"  v-if="scope.row.doc_type==4">
            {{ getWorkspaceStatusText2(scope.row.inWorkspaceCount,  scope.row.totalQaCount) }}
          </el-tag>          
        </template>
      </el-table-column>      
      
      <el-table-column prop="createdAt" label="上传时间" width="160">
        <template slot-scope="scope">
          {{ formatToBeijingTime(scope.row.created_at) }}
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <el-button v-if='scope.row.doc_type==3  || scope.row.doc_type==4' @click="HandleEditDocument(scope.row)" size="mini" type="text" icon="el-icon-edit">
               编辑
            </el-button>          
          <el-button type="text" v-if="scope.row.doc_type===3 && scope.row.is_in_document_library===true && scope.row.isInWorkspace== false" size="small" @click="handleEmbed(scope.row)">嵌入知识库</el-button>
          <el-button type="text" size="small" style="color: #f56c6c;" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination    
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
      style="margin-top: 20px; text-align: right; z-index: 9999;">
    </el-pagination>
    
    <!-- 文档详情对话框 -->
    <el-dialog title="文档详情" :visible.sync="detailVisible" width="600px" append-to-body>
      <el-form :model="currentDoc" label-width="100px">
        <el-form-item label="文档名称">
          <span>{{ currentDoc.title }}</span>
        </el-form-item>
        <el-form-item label="文档类型">
          <span v-if="currentDoc.doc_type == 1">文件</span>
          <span v-else-if="currentDoc.doc_type == 2">在线网页</span>
          <span v-else-if="currentDoc.doc_type == 3">图文文档</span>
          <span v-else-if="currentDoc.doc_type == 4">问答对文档</span>          
        </el-form-item>
        <el-form-item label="状态">
          <el-tag :type="getLiabraryStatusType(currentDoc.status, currentDoc.is_in_document_library)" size="small">
            {{ getLiabraryStatusText(currentDoc.status) }}
          </el-tag>
        </el-form-item>
        <el-form-item label="上传时间">
          <span>{{ formatToBeijingTime(currentDoc.created_at) }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    
    <!-- 嵌入知识库对话框 -->
    <el-dialog title="嵌入知识库" :visible.sync="embedVisible" width="400px" append-to-body>
      <el-select v-model="selectedWorkspaceSlug" placeholder="请选择目标知识库" style="width: 100%;">
        <el-option
          v-for="ws in workspaceList"
          :key="ws.slug"
          :label="ws.name"
          :value="ws.slug">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
            <el-button 
      type="primary" 
      @click="confirmEmbed" 
      :loading="embedLoading"
      :disabled="embedLoading || !selectedWorkspaceSlug"
    >
      <template v-if="!embedLoading">确 定</template>
      <template v-else>处理中...</template>
    </el-button>
        <!--el-button type="plain" @click="embedVisible = false">取 消</el-button-->
      </div>
    </el-dialog>

  <!-- 新建/编辑图文文档对话框 -->
      <el-dialog
        title=" 图文编辑器"
        :visible.sync="open_editor"
        width="95%"
        top="2vh"
        append-to-body
        :close-on-click-modal="false"
        custom-class="editor-dialog"
      >
        <AnythingllmRichEditor
          v-if="open_editor"
          ref="editorComponent"
          :edit-data="currentEditDoc"
          :default-dir-id="defaultDirId"
          :userName="userName"
          :tenantId = "tenantId"
          :dir-list="editorDirList"
          :workspaceSlug="defaultWorkspaceSlug"          
          @content-change="onEditorContentChange"
          @dir-change="onEditorDirChange"
        />
      </el-dialog>    
    <!-- 全局文档库：问答对编辑器对话框 -->
    <el-dialog 
    title="问答对编辑器" 
    :visible.sync="QAeditorVisible" 
    width="85%" 
    top="3vh"
    append-to-body
    :close-on-click-modal="false"
    @closed="onQAEditorClosed"
  >
    <QAeditor
      v-if="QAeditorVisible"
      ref="qaEditorRef"
      :docId="currentQADocId"
      :doctitle="currentQADocTitle"
      :dirs="dirs"
      :defaultDirId="currentQADocDirId"
      :workspace_slug="defaultWorkspaceSlug"
      :tenantId="tenantId"
      :username="userInfo.username"
      @doc-created="onQADocCreated"
      @qa-changed="onQAChanged"
    />
  </el-dialog>            
  </div>
</template>

<script>
import { query_document_details,listDocuments_in_folder, deleteDocument, listAllDirs, getDocumentStatic_by_tenant, query_richdoc_details,listBriefDirsByTenantid } from '@/api/aics/KbDocument';
import { listKbWorkspaces_by_tenantId, EmbeddingDoc } from '@/api/aics/kbWorkspace';
//import AnythingllmUploadDocument from '@/components/kb_workspace/AnythingllmUploadDocument.vue';
import {formatToBeijingTime }  from '@/util/date'
import AnythingllmRichEditor from "@/components/aics/AnythingllmRichEditor.vue";
import QAeditor from "@/components/kb_workspace/QAeditor.vue";
import { mapState } from 'vuex';

export default {
  name: 'GlobalLibrary',
   components: {
    AnythingllmRichEditor,
    QAeditor,
   },
  props: {
    tenantId: {
      type: [String, Number],
      required: true
    },

      workspaceSlug: {
      type: String,
      default: ""
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      docList: [],
      dirs: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      docType: 0,
      selectedDirId: null,
      keyword: '',
      detailVisible: false,
      currentDoc: {},
      docStats: null,
      //maxFileCount: 1000,
      //maxStorageSpace: 1024,
      // 嵌入相关
      embedVisible: false,
      selectedWorkspaceSlug: '',
      workspaceList: [],
      defaultWorkspaceSlug: '',   // 新增：默认知识库slug
      currentEmbedDoc: null,
      embedLoading: false,      // 嵌入操作加载状态
      currentDirName: '',     // 文档所在目录
      title: '',              // 文档标题 
   // 图文编辑器相关
      open_editor: false,
      open_preview: false,
      editorDialogTitle: '新建图文文档',      
      currentEditDoc: null,
      editorHasContent: false,
      editorDirList: [],      
      currentPreviewDoc: null,
      submitting: false,
      defaultDirId: null, // 默认目录ID，可以从现有逻辑获取      
    // 问答对编辑器相关
      QAeditorVisible: false,
      currentQADocId: 0,
      currentQADocTitle: '',
      currentQADocDirId: null,

      doc_id: 0,
    }
  },
  computed: {
    ...mapState('auth', ['tenantInfo', 'userInfo']),
    maxFileCount() {
      return this.tenantInfo?.maxFileCount || 1000;
    },
    maxStorageSpace() {
      return this.tenantInfo?.maxStorageSpace || 1024;
    }
  },
  mounted() {
    this.doc_id =0;
    console.log(", 'userInfo'", this.userInfo)

    this.currentDirName = '/';
    this.init();
    this.loadWorkspaceList();
  },
  methods: {    
    formatToBeijingTime (date){
      return formatToBeijingTime(date)
    },
    // 供父组件调用的刷新方法
    async refresh() {
      await this.init();
      return this.loadData();
    },
    debugLog(data) {
    console.log('row data:', JSON.stringify(data));
    return ''; // 返回空字符串，不影响渲染
  },
    async init() {
      await this.loadDirs();
      await this.loadDocStats();
    },
    
    // 加载目录列表
    async loadDirs() {
      try {
        // 全局文档库模式下，需要一个有效的 workspaceSlug 来获取目录
        // 先获取租户的工作区列表，取第一个工作区的 slug
        const workspacesRes = await listKbWorkspaces_by_tenantId(this.tenantId);
        const workspaces = workspacesRes?.data || [];
        if (workspaces.length === 0) {
          console.warn('没有找到工作区，无法加载目录');
          return;
        }
        
        const workspaceSlug = workspaces[0].slug;
        const res = await listAllDirs(workspaceSlug);
        
        if (res.code === 200 && res.data) {
          this.dirs = res.data;
          if (this.dirs.length > 0 && !this.selectedDirId) {
            this.selectedDirId = this.dirs[0].id;
          }
        }
      } catch (error) {
        console.error('加载目录列表失败:', error);
      }
    },
    
    // 加载工作区列表（用于嵌入）
    async loadWorkspaceList() {
      try {
        const res = await listKbWorkspaces_by_tenantId(this.tenantId);
        console.log("listKbWorkspaces_by_tenantId", res);
        this.workspaceList = res?.data || [];
        console.log("  this.workspaceList",   this.workspaceList);
        // 如果有知识库，设置第一个为默认选中
        if (this.workspaceList.length > 0) {
          this.defaultWorkspaceSlug = this.workspaceList[0].slug;
          this.selectedWorkspaceSlug = this.defaultWorkspaceSlug;  // 设置当前选中
        }        
        console.log("this.defaultWorkspaceSlug", this.defaultWorkspaceSlug);
        console.log("this.selectedWorkspaceSlug", this.selectedWorkspaceSlug);
      } catch (error) {
        console.error('加载工作区列表失败:', error);
      }
    },
    
    // 加载文档统计数据
    async loadDocStats() {
      try {
        const res = await getDocumentStatic_by_tenant(this.tenantId, this.userName);
        console.log("getDocumentStatic_by_tenant - res", res)
        if (res.code === 200 && res.data) {
          const storageMB = (res.data.storage_space / 1024.0 / 1024.0).toFixed(2);
          console.log("storageMB", storageMB)
          this.docStats = {
            count: res.data.doc_count || 0,
            storage: storageMB
          };
          console.log("this.docStats", this.docStats)
        }
      } catch (error) {
        console.error('加载统计失败:', error);
      }
    },
    
    // 加载文档列表
    async loadData() {
      this.loading = true;
      try {
        // 获取第一个工作区的 slug 作为参数
        const workspacesRes = await listKbWorkspaces_by_tenantId(this.tenantId);
        console.log("listKbWorkspaces_by_tenantId(workspacesRes)",workspacesRes);
        const workspaces = workspacesRes.data || [];
        if (workspaces.length === 0) {
          console.warn('没有找到工作区');
          this.loading = false;
          return;
        }
        
        const workspaceSlug = workspaces[0].slug;
        const params = {
          docType: this.docType !== null && this.doc_type !== '' ? Number(this.docType) : 0,
          dir_id: this.selectedDirId !== null ? this.selectedDirId : 0,
          keyword: this.keyword || '',
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        console.log("listDocuments_in_folder", workspaceSlug, params)
        const res = await listDocuments_in_folder(workspaceSlug, params);
        console.log("listDocuments_in_folder", res)
        if (res.code === 200) {
          this.docList = res.data.list || [];

          this.total = res.data.total || 0;
          console.log("listDocuments_in_folder res", this.docList, this.total)
        } else {
//          this.$message.error(res.message || '加载失败');
        }
      } catch (error) {
        console.error('加载文档失败:', error);
        this.$message.error('加载文档失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 编辑器内容变化
    onEditorContentChange(formData) {
      this.editorHasContent = !!(formData.htmlContent && formData.htmlContent.trim())
    },

    // 编辑器目录变化
    onEditorDirChange(dirId) {
      console.log('目录变更:', dirId)
    },    
    HandleDocDetail(row) {
      console.log(row);
      query_document_details(row.id).then(res => {
        console.info("HandleDocDetail",res);
        this.form_details = res.data;
        this.open_details = true;
      });
    },     
    handleSearch() {
      this.pageNum = 1;
      this.loadData();
    },
    
      async HandleEditDocument(row) {
        console.log("HandleEditDocument", row)
        console.log('【点击编辑】当前 defaultWorkspaceSlug:', this.defaultWorkspaceSlug);
        console.log('【点击编辑】workspaceList 长度:', this.workspaceList.length);                    
        try {    
          if(row.doc_type===3){
          
          // 获取数据
          const res = await query_richdoc_details(row.id);    
          if (res.code === 200 && res.data) {
            const docData = res.data;
            

            // 获取文档的目录ID（可能需要从其他接口获取）
            // 暂时先设置一个默认值
            const defaultDirId = this.dirs && this.dirs.length > 0 ? this.dirs[0].id : null;
            
            const editorData = {
              id: row.id,
              title: docData.title || '',
              dirId: docData.dirId || defaultDirId, // 确保有目录ID
              description: docData.description || '',
              docAuthor: docData.docAuthor || this.userName,
              html_content: docData.html_content || '',
              htmlContent: docData.html_content || '',
              markdown_content: docData.markdown_content || '',
              markdownContent: docData.markdown_content || '',
              image_references: docData.image_references || '',
              imageReferences: docData.image_references || ''
            };
            
            console.log('传递给编辑器的数据 - dirId:', editorData.dirId);
            
            this.currentEditDoc = editorData;
            this.editorDialogTitle = editorData.title?.trim() || '新图文文档';
       
             console.log('【打开编辑器前】defaultWorkspaceSlug:', this.defaultWorkspaceSlug);
            this.open_editor = true;
            //this.workspaceSlug = this.defaultWorkspaceSlug;
     
          } else {
            this.$message.error('获取文档详情失败');
          }

    
          }
          else if(row.doc_type === 4){ //问答对编辑器
this.currentQADocId = row.id
          this.currentQADocTitle = row.title
          
          // 获取文档详情获取目录ID
          try {
            const res = await query_document_details(row.id)
            if (res.code === 200 && res.data) {
              this.currentQADocDirId = res.data.dirId || null
            }
          } catch (error) {
            console.error('获取文档详情失败:', error)
            this.currentQADocDirId = null
          }
           
          // 加载目录列表
          try {
            const res = await listBriefDirsByTenantid(this.tenantId)
            if (res.data && res.data.code === 200) {
              this.dirs = res.data.data || []
            }
          } catch (error) {
            console.error('加载目录列表失败:', error)
          }
          
          // 打开对话框
          this.$nextTick(() => {
            this.QAeditorVisible = true
          })
        }   
     
      } catch (error) {
        console.error("获取文档详情失败:", error)
        this.$message.error('获取文档详情失败: ' + error.message)
      }                

  // ★★★ 关键：在打开对话框前才设置标题和ID ★★★
       this.title = row.title;
       this.doc_id = row.id;   
       // 使用 $nextTick 确保数据更新后再打开对话框
       if(row.doc_type === 4){ //问答对编辑器
          this.$nextTick(() => {
            this.QAeditorVisible = true;
          })             
      }
          
   /*   } catch (error) {
          console.error("获取文档详情失败:", error);
          this.$message.error('获取文档详情失败: ' + error.message);
      }      */
        

      },    
    handleSizeChange(val) {
      
      this.pageSize = val;
      this.loadData();
    },
    
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    
    handleDetail(row) {
      console.log("handleDetail", row);
       this.doc_id = row.id
      this.currentDoc = row;
      this.detailVisible = true;
    },
    
    handleEmbed(row) {
      if (this.workspaceList.length === 0) {
        this.$message.warning('没有可用的知识库');
        return;
      }
      this.currentEmbedDoc = row;
      // 重置为默认选中的知识库
      this.selectedWorkspaceSlug = this.defaultWorkspaceSlug;
      this.embedVisible = true;
    },
    
    async confirmEmbed() {
      if (!this.selectedWorkspaceSlug) {
        this.$message.warning('请选择目标知识库');
        return;
      }
        // 开始加载
  this.embedLoading = true;
      try {
        const res = await EmbeddingDoc(this.tenantId, this.currentEmbedDoc.id, this.selectedWorkspaceSlug);
        console.log("EmbeddingDoc", res)
        if (res.data && (res.data.code === 200 ||res.code === 200)) {
          this.$message.success('嵌入成功');
          this.embedVisible = false;
           this.embedVisible = false;
          this.loadData();
        } else {
          this.$message.error(res.message || '嵌入失败');
        }
      } catch (error) {
        console.error('嵌入失败:', error);
        this.$message.error('嵌入失败');
      } finally {
    // 无论成功失败，都要结束加载状态
    this.embedLoading = false;
  }
    },
    
    async handleDelete(row) {
      try {
        await this.$confirm('删除后将无法恢复，确定删除吗？', '提示', { type: 'warning' });
        const res = await deleteDocument(row.id);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.loadData();
          this.loadDocStats();
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败');
        }
      }
    },   
    getLiabraryStatusText(status, is_in_document_library) {
/*      const map = {
        0: '不在文档库中',
        1: '待处理',
        2: '处理中',
        3: '已训练',
        4: '已移除'
      };*/
      if(status ==1)
        return '待处理';
      else if(status ==2)
        return '处理中';      
      else if(status ==4)
        return '已移除';  

      if(!is_in_document_library)
        return '不在全局文档库中';
      else return '已在全局文档库中';

      //return map[status] || '未知';
    },  
     getLiabraryStatusText2(inLibraryCount,  totalQaCount){
        return inLibraryCount+'/'+ totalQaCount;
     },
    getLiabraryStatusType(status, is_in_document_library){
      console.log("getLiabraryStatusType", status, is_in_document_library)
      
      // 如果不在文档库中，显示 danger
      if (!is_in_document_library) {
        return 'danger'
      }
      
      // 如果在文档库中，根据状态显示
      if (status == 1) return 'info'      // 待处理
      if (status == 2) return 'warning'   // 处理中
      if (status == 3) return 'success'   // 已完成
      
      return 'info' // 默认
    },
    getLiabraryStatusType2(inLibraryCount,  totalQaCount){
      console.log("getLiabraryStatusType2",inLibraryCount,  totalQaCount)
      if(inLibraryCount>totalQaCount)
        return 'danger'
      if(inLibraryCount <=0 || totalQaCount<=0 || inLibraryCount>totalQaCount)
          return 'warning'
    },
    getWorkspaceStatusType(isInWorkspace){
      if(isInWorkspace)
        return 'success';        
      else
        return 'danger'      

    },
    getWorkspaceStatusText(isInWorkspace){
      if(isInWorkspace) return '已训练';
      else return '不在知识库中';
    },
    getWorkspaceStatusText2(inWorkspaceCount,  totalQaCount){
       return inWorkspaceCount + '/'+totalQaCount;
    },
    formatSize(bytes) {
      if (!bytes) return '-';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
      return (bytes / 1024 / 1024).toFixed(2) + ' MB';
    },

    submitQAitem(){

    },

    onGlobalUploadSuccess() {
      this.globalUploadVisible = false;
      this.refreshGlobalLibrary();
    },    

// 问答对文档创建成功回调
    onQADocCreated(docId) {
      this.currentQADocId = docId
      this.$message.success('文档创建成功，可以开始添加问答对')
    },

    // 问答对变更回调
    onQAChanged(qaPairs) {
      console.log('问答对已变更，当前数量:', qaPairs.length)
      // 可以在这里更新文档列表中的问答对计数
    },

    // 问答对编辑器关闭回调
    onQAEditorClosed() {
      // 刷新文档列表
      this.loadData()
      this.loadDocStats()
      this.currentQADocId = 0
      this.currentQADocTitle = ''
      this.currentQADocDirId = null
    },

    // 新增问答对文档（从工具栏调用）
    handleAddQADocument() {
      this.currentQADocId = 0
      this.currentQADocTitle = ''
      this.currentQADocDirId = this.selectedDirId || null
      
      // 加载目录列表
      listBriefDirsByTenantid(this.tenantId).then(res => {
        if (res.data && res.data.code === 200) {
          this.dirs = res.data.data || []
        }
        this.$nextTick(() => {
          this.QAeditorVisible = true
        })
      }).catch(error => {
        console.error('加载目录列表失败:', error)
        this.$nextTick(() => {
          this.QAeditorVisible = true
        })
      })
    }    
  }
}

</script>

<style scoped>
.global-library {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;  /* 防止整体溢出 */
}
/* 让表格自动撑满剩余空间 */
.el-table {
  flex: 1;
  overflow: auto;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.toolbar-left {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.stats-bar {
  background: #f0f9eb;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #67c23a;
  display: flex;
  gap: 20px;
}

/* 深色主题 */
@media (prefers-color-scheme: dark) {
  .stats-bar {
    background: #2d3e2d;
    color: #95d475;
  }
}
</style>